import { Modal } from '@adiox/ui';

const GROUPS: { title: string; keys: [string, string][] }[] = [
  {
    title: 'Anywhere',
    keys: [
      ['F9', 'New order'],
      ['Ctrl+D', 'Data Window'],
      ['?', 'This list'],
      ['Esc', 'Close a dialog or menu'],
    ],
  },
  {
    title: 'Chart (when it is the active panel)',
    keys: [
      ['1 – 9', 'Timeframe M1, M5, M15, M30, H1, H4, D1, W1, MN1'],
      ['Type a symbol or timeframe', 'Switch this chart ("GBPUSD", "H4", "GBPUSD H4"), then Enter'],
      ['+  /  −', 'Zoom in / out'],
      ['End', 'Go to the latest bar'],
      ['F12', 'Step one bar forward'],
      ['Alt+1  /  Alt+2  /  Alt+3', 'Bars / candles / line'],
      ['Ctrl+G', 'Grid on or off'],
      ['Ctrl+L', 'Volumes on or off'],
      ['Ctrl+Y', 'Period separators on or off'],
      ['F8', 'Chart properties'],
      ['Ctrl+B', 'Objects list (drawings on this chart)'],
      ['Ctrl+Z  /  Ctrl+Shift+Z', 'Undo / redo a drawing change'],
      ['Delete', 'Delete the selected drawing'],
      ['Esc', 'Stop drawing, or deselect'],
      ['Alt+B  /  Alt+S', 'Buy / sell at once (only with one-click trading on)'],
    ],
  },
  {
    title: 'Market Watch',
    keys: [
      ['↑  /  ↓', 'Move between symbols'],
      ['Enter', 'Show the symbol in charts and the order ticket'],
      ['Double-click', 'New order on the symbol'],
      ['Alt+↑  /  Alt+↓', 'Move the symbol up or down the list'],
      ['Delete', 'Hide the symbol'],
      ['Shift+F10', 'Menu for the symbol (or right-click)'],
    ],
  },
  {
    title: 'Menus',
    keys: [
      ['↑  /  ↓', 'Move'],
      ['Enter', 'Choose'],
      ['Esc', 'Close'],
    ],
  },
];

/** Every keyboard shortcut of the terminal in one place (press ? to open it). */
export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal open={open} title="Keyboard shortcuts" onClose={onClose} size="md">
      <div className="flex max-h-[70vh] flex-col gap-4 overflow-auto pr-1">
        {GROUPS.map((g) => (
          <section key={g.title} aria-label={g.title}>
            <h3 className="mb-1 text-xs font-semibold uppercase tracking-wide text-muted">{g.title}</h3>
            <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
              {g.keys.map(([key, what]) => (
                <div key={`${g.title}-${key}-${what}`} className="contents">
                  <dt>
                    <kbd className="num whitespace-nowrap rounded border border-line bg-panel2 px-1.5 py-0.5 text-xs">
                      {key}
                    </kbd>
                  </dt>
                  <dd>{what}</dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
      <div className="mt-4 flex justify-end">
        <button
          type="button"
          onClick={onClose}
          className="rounded-md border border-line px-4 py-1.5 text-sm hover:border-accent"
        >
          Done
        </button>
      </div>
    </Modal>
  );
}
